import React, { useEffect, useState } from "react";
import { useSelector, shallowEqual, useDispatch } from "react-redux";
import Select from 'react-select';
import { MediaBaseUrl, PROFILE_UPDATE } from "../../../../actions/api";
import ImageUpload from "./Components/ImageUpload";
import HttpClient from '../../../../actions/http-client';
import { TOAST_SUCCESS, validateEmail, checkIfStringHasSpecialChar, TOAST_DISMISS, TOAST_ERROR } from '../../../../utils'; 
import { getUserInfo } from "../../../../actions/loginActions";
import { useNavigate } from "react-router-dom";
import PasswordConfirmationPop from "./Components/PasswordConfirmationPop";
import { Button, Image } from "react-bootstrap";
import { FontAwesomeIcon } from "../../../CommonComponents/AssetsHelper";

const options = [
    { value: "Automotive", label: "Automotive" },
    { value: "Agency", label: "Agency" },
    { value: "E-Commerce", label: "E-Commerce" },
    { value: "Education", label: "Education" },
    { value: "Entertainment", label: "Entertainment" },
    { value: "Non-Profit", label: "Non-Profit" },
    { value: "Government", label: "Government" },
    { value: "Food & Beverage", label: "Food & Beverage" },
    { value: "Retail", label: "Retail" },
    { value: "Sports", label: "Sports" },
    { value: "Travel", label: "Travel" },
    { value: "Venues", label: "Venues" },
]

const blankImage = ``;
function Profile() {
    const [confirmPassNotMatch, setConfirmPassMatch] = useState(false);
    const [removeProfilePic, setRemoveProfilePic] = useState(false);
    const [uploadImageSrc, setuploadImageSrc] = useState(blankImage);
    const { userData } = useSelector(state => state.authenticated, shallowEqual);
    const [emailErrMsg, setEmailErrMsg] = useState('');
    const user = userData ? userData.user : [];
    const name = user && Object.keys(user).length > 0 ? user.name : '';
    const email = user && Object.keys(user).length > 0 ? user.emailId : '';
    const picture = user && Object.keys(user).length > 0 ? user.picture : '';
    const fullName = name.split(' ');
    const userFirstName = name != '' ? fullName[0] : '';
    const userLastName = name != '' && fullName.length > 1 ? name.split(' ')[(fullName.length - 1 && fullName.length > 1) ? fullName.length - 1 : 1] : '';
    const selectedOrganization = user && Object.keys(user).length > 0 ? user.organization : '';
    const selectedIndustry = user && Object.keys(user).length > 0 ? user.industry : '';
    const [loaderBtn, updateProfileLoader] = useState(false);
    const [firstNameError, setFirstNameError] = useState(false);
    const [lastNameError, setLastNameError] = useState(false);
    const [orgNameError, setorgNameError] = useState(false);
    const dispatch = useDispatch();
    const history = useNavigate();
    const [selectedOption, setSelectedOptions] = useState(selectedIndustry !== '' ? { value: selectedIndustry, label: selectedIndustry } : null);
    const [state, setState] = useState({
        firstName: userFirstName,
        lastName: userLastName,
        email: email,
        industry: selectedIndustry !== '' ? selectedIndustry : null,
        organization: selectedOrganization,
        password: '',
        confirmPassword: ''
    });
    const [showPassPop, setShowPassPop] = useState(false);

    const onImgUpload = src => {
        setRemoveProfilePic(true);
        setuploadImageSrc(src);
    }

    const handleSubmit = (e) => {
        if (state.password.length > 0 && (state.password !== state.confirmPassword)) {
            setConfirmPassMatch(true);
        } else if (state.email.length == 0) {
            setEmailErrMsg("This field is required");
        } else if (checkIfStringHasSpecialChar(state.firstName)) {
            setFirstNameError(true);
        } else if (checkIfStringHasSpecialChar(state.lastName)) {
            setLastNameError(true);
        } else if (checkIfStringHasSpecialChar(state.organization)) {
            setorgNameError(true);
        } else if (confirmPassNotMatch) {
            setConfirmPassMatch(false);
            setEmailErrMsg('');
        } else if(!validateEmail(state.email)){
            setEmailErrMsg("Email is not valid.");
        }else if (user.oauth_provider == '' && (state.email != email || state.password.length > 0)) {
            setShowPassPop(true);
        } else {
        updateProfileLoader(true); 
        callUpdateProfile('')
    }
    }

    const callUpdateProfile = (currentPassword) => {
        updateProfile({
            organization: state.organization,
            fullName: (state.firstName + " " + state.lastName),
            email: state.email,
            industry: state.industry,
            password: state.password,
            currentPassword:currentPassword,
            picture: (uploadImageSrc !== blankImage ? uploadImageSrc : `https://ui-avatars.com/api/?name=${state.firstName}&background=fff4de&color=ffa800&length=1`)
        });
    }

    const handleSelectChange = (e) => {
        setState({ ...state, industry: e.value });
        setSelectedOptions(e);
    }

    const handleOnChange = (e) => {
        if (confirmPassNotMatch) {
            setConfirmPassMatch(false);
        }
        setFirstNameError(false);
        setLastNameError(false);
        setorgNameError(false);
        setEmailErrMsg('');
        setState({ ...state, [e.target.name]: e.target.value });
    }

    const removeImage = () => {
        if (uploadImageSrc !== blankImage) {
            setuploadImageSrc(blankImage);
        }
        setRemoveProfilePic(false);
    }

    const updateProfile = (profile) => {
        new HttpClient().post(PROFILE_UPDATE, profile).then((response) => {
            const { responseMessage } = response.data;
            TOAST_SUCCESS(responseMessage);
            dispatch(getUserInfo(history, false, false, true));
            updateProfileLoader(false);  setShowPassPop(false)
            setTimeout(() => {
                TOAST_DISMISS();
            }, 2000);
        }).catch(ex => {
            const { data } = ex.response;
            const { responseMessage, responseCode } = data;
            updateProfileLoader(false);
            if (responseCode == 403) {
                setEmailErrMsg(responseMessage);
            } else {
                TOAST_ERROR(responseMessage);
            }
        })
    }

    useEffect(() => {
        if (picture.length > 0) {
            setRemoveProfilePic(true);
            setuploadImageSrc(picture);
        }
    }, [])

    return <div className="profile_info">
        <div className="d-flex flex-column-fluid main_content no_subheader">
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <div className="profilePageContnt profile-margin">
                            <div className="dashContent">
                                <div className="row justify-content-center">
                                    <div className="col-xl-8 col-lg-10">
                                        <div className="card card-custom dashTable">
                                            <div className="card-header py-3">
                                                <div className="card-title align-items-start flex-column">
                                                    <h3 className="card-label font-weight-bolder text-dark mb-2">My Profile</h3>
                                                    <span className="text-muted font-weight-bold font-size-sm">View/Edit your personal information</span>
                                                </div>
                                            </div>
                                            <div className="card-body p-5" id="persnalDtls">
                                                <div className="mb-5">
                                                    <div className="form-group text-center">
                                                        <label className="control-label w-100 fw-bold">Profile Picture*</label>
                                                        <div className="image-input image-input-outline fileinput fileinput-new position-relative" data-provides="fileinput">
                                                            <div className="fileinput-preview thumbnail profileThumb" data-trigger="fileinput">
                                                                <div className="symbol symbol-100 symbol-light-warning">
                                                                    {removeProfilePic ? <img className="image-input-wrapper" id="file-preview-Img" src={uploadImageSrc} height={100} width={100} alt={state.firstName} /> :
                                                                        <span id="profileImage" className="symbol-label font-size-h1 font-weight-bold text-uppercase">{state.firstName.length > 0 ? state.firstName[0] : ''}</span>}
                                                                    <span className="premium-user-sign user-sign-dropdown-sign">
                                                                        {user && user.isPremiumUser === 1 ? <Image src={`${MediaBaseUrl}svg/icons/profile-star.svg`} className="img-fluid" alt="profile star" width={'20'} height={'20'} /> : null}
                                                                    </span>
                                                                    <div className="profileAction d-flex align-items-center justify-content-between position-absolute">
                                                                        <ImageUpload onImgUpload={onImgUpload} />
                                                                        <Button variant="light" id="removeProfile" className="p-0 border-0 rounded-circle h-24px w-24px shadow bg-white btn-link" data-dismiss="fileinput" onClick={() => removeImage()}>
                                                                            <FontAwesomeIcon type={'solid'} icon={'xmark'} iconClass={'fs-6 text-muted'}/> 
                                                                        </Button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="profileForm">
                                                    <div className="row">
                                                        <div className="col-sm-6">
                                                            <div className="form-group">
                                                                <div className="input text"><label htmlFor="ProfileFirstName" className="fw-bold">First Name</label>
                                                                    <input className="form-control" placeholder="First Name" defaultValue={state.firstName} type="text" id="ProfileFirstName" name="firstName" onChange={handleOnChange} />
                                                                </div>
                                                                {firstNameError && <span id="profilefirstNameerror" className="errorMessage required">Special characters are not allowed. Enter Proper Name</span>}
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-6">
                                                            <div className="form-group">
                                                                <div className="input text"><label htmlFor="ProfileLastName" className="fw-bold">Last Name</label><input name="lastName" className="form-control" placeholder="Last Name" defaultValue={state.lastName} id="ProfileLastName" onChange={handleOnChange} /></div>
                                                                {lastNameError && <span id="profileemailIderror" className="errorMessage required">Special characters are not allowed. Enter Proper Last Name</span>}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-sm-6">
                                                            <div className="form-group">
                                                                <div className="input email"><label htmlFor="ProfileEmailId" className="fw-bold">Email Id</label><input name="email" className="form-control" placeholder="Email Id" defaultValue={state.email} type="email" id="ProfileEmailId" onChange={handleOnChange} /></div>
                                                                {emailErrMsg.length > 0 && <span id="profileemailIderror" className="errorMessage required">{emailErrMsg}</span>}
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-6">
                                                            <div className="form-group">
                                                                <div className="input select"><label htmlFor="ProfileIndustry" className="fw-bold">Industry</label>
                                                                    <Select menuPlacement="auto" classNamePrefix="selectpicker" onChange={(e) => handleSelectChange(e)} options={options} defaultValue={selectedOption} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-sm-6">
                                                            <div className="form-group">
                                                                <div className="input text"><label htmlFor="ProfileOrganization" className="fw-bold">Organization</label><input name="organization" className="form-control" placeholder="Organization" defaultValue={state.organization} type="text" id="ProfileOrganization" onChange={handleOnChange} autoComplete={'new-password'} /></div>
                                                                {orgNameError && <span id="profilepassworderror" className="errorMessage required">Special characters are not allowed. Enter Proper Organization Name
                                                                </span>}

                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-sm-12 mt-3 mb-4">
                                                            <div className="border-bottom">
                                                                <h5>Update Password</h5>
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-6">
                                                            <div className="form-group">
                                                                <div className="input password"><label htmlFor="ProfilePassword" className="fw-bold">Password</label><input name="password" placeholder="Password" defaultValue={state.password} className="form-control placeholder-no-fix" type="password"  id="ProfilePassword" onChange={handleOnChange} autoComplete={'new-password'} /></div>

                                                            </div>
                                                        </div>
                                                        <div className="col-sm-6">
                                                            <div className="form-group">
                                                                <div className="input password"><label htmlFor="ProfileRpassword" className="fw-bold">Confirm Password</label><input name="confirmPassword" placeholder="Re-type Your Password" defaultValue={state.confirmPass} className="form-control placeholder-no-fix" type="password" id="ProfileRpassword" onChange={handleOnChange} autoComplete={'off'} /></div>
                                                                {confirmPassNotMatch && <span id="profilerpassworderror" className="errorMessage required">The passwords you entered do not match.
                                                                </span>}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="card-footer border-top text-end p-3">
                                                <button type="submit" className={`btn btn-primary${loaderBtn && !showPassPop  ? ' spinner spinner-right' : ''}`} onClick={(e) => handleSubmit(e)}>
                                                <FontAwesomeIcon type={'solid'} icon={'pencil'} iconClass={'fs-6 me-1'}/>  Update Profile</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <PasswordConfirmationPop closecustomPost={() => setShowPassPop(false)} {...{callUpdateProfile, showPassPop, loaderBtn, updateProfileLoader}}  />
    </div>
}

export default Profile;
